// File: src/components/car/BenefitsAddons.jsx
import React from 'react';
import './BenefitsAddons.css';

const BenefitsAddons = ({ car }) => {
  console.log(' BenefitsAddons received car:', car);
  console.log('📋 car_benefits data:', car?.car_benefits);
  
  const benefits = car?.car_benefits || [];
  
  // Default benefits matching Spinny's structure
  const defaultBenefits = [
    { 
      title: 'Up to 1 year warranty', 
      icon: '🛡️', 
      included: true, 
      description: 'Extended coverage on major components'
    },
    { 
      title: '250-points inspected', 
      icon: '✓', 
      included: true, 
      description: 'Comprehensive quality check'
    },
    { 
      title: '5-day money back', 
      icon: '💰', 
      included: true, 
      description: 'Return if not satisfied'
    },
    { 
      title: 'Fixed price assurance', 
      icon: '💵', 
      included: true, 
      description: 'No hidden charges'
    },
    { 
      title: 'Roadside assistance', 
      icon: '🚗', 
      included: true, 
      description: '24/7 emergency support'
    },
    { 
      title: 'Buyback guarantee', 
      icon: '🔄', 
      included: false, 
      description: 'Available as add-on'
    }
  ];
  
  // Use backend data if available, otherwise use defaults
  const displayBenefits = (Array.isArray(benefits) && benefits.length > 0) 
    ? benefits 
    : defaultBenefits;
  
  const includedCount = displayBenefits.filter(b => b.included !== false).length;
  
  // Find extended warranty benefit (if exists)
  const extendedWarranty = displayBenefits.find(b => 
    b.title.toLowerCase().includes('warranty') && b.included
  );
  
  console.log('✅ Display benefits:', displayBenefits);
  console.log('📊 Included count:', includedCount);
  
  return (
    <div className="benefits-addons-section">
      <div className="benefits-header">
        <h3 className="section-title">Benefits & add-ons</h3>
        <span className="max-badge">
          <span className="max-icon">⚡</span> MAX
        </span>
      </div>
      
      <div className="benefits-grid">
        {displayBenefits.map((benefit, index) => (
          <div 
            key={index} 
            className={`benefit-card ${benefit.included === false ? 'not-included' : ''}`}
          >
            <div className="benefit-icon-wrapper">
              <span className="benefit-icon">{benefit.icon}</span>
            </div>
            <div className="benefit-content">
              <strong className="benefit-title">{benefit.title}</strong>
              {benefit.description && (
                <span className="benefit-desc">{benefit.description}</span>
              )}
            </div>
          </div>
        ))}
      </div>
      
      {/* Extended Warranty Banner */}
      {extendedWarranty && (
        <div className="extended-warranty-banner">
          <div className="warranty-icon">🛡️</div>
          <div className="warranty-content">
            <strong>10 month additional warranty</strong>
            <span>Get extended coverage at ₹60,000</span>
          </div>
          <button className="warranty-info-btn">ℹ️</button>
        </div>
      )}
    </div>
  );
};

export default BenefitsAddons;